import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div data-testid="payment-cancel-page" className="bg-[#090D16] text-slate-100 min-h-screen">
      <div className="noise-overlay" />
      <header className="border-b border-slate-800 bg-[#090D16]/90 backdrop-blur-xl">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center">
          <a href="/" data-testid="cancel-logo-link"><Logo compact /></a>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 sm:px-6 py-24 text-center">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <div className="mx-auto w-24 h-24 rounded-full bg-[#FF087B]/15 border-2 border-[#FF087B] flex items-center justify-center">
            <XCircle className="w-12 h-12 text-[#FF087B]" />
          </div>
          <h1 className="mt-8 font-display text-6xl uppercase tracking-wide text-white leading-none" data-testid="cancel-title">
            Betaling geannuleerd
          </h1>
          <p className="mt-4 text-slate-400">
            Geen zorgen — er is niets afgeschreven. Je winkelmand is bewaard gebleven, dus je kunt gewoon opnieuw afrekenen.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              data-testid="cancel-retry-checkout"
              onClick={() => navigate("/checkout")}
              className="bg-gradient-to-r from-[#00FF66] to-[#00E5FF] text-slate-950 font-extrabold uppercase tracking-wider px-8 py-4 rounded-full glow-lime hover:scale-105 active:scale-95 transition-transform"
            >
              Opnieuw afrekenen
            </button>
            <button
              data-testid="cancel-back-to-shop"
              onClick={() => navigate("/")}
              className="bg-slate-800 hover:bg-slate-700 border border-slate-700 text-white font-bold px-8 py-4 rounded-full transition-colors"
            >
              Terug naar de shop
            </button>
          </div>
        </motion.div>
      </main>
    </div>
  );
}
